import './_tabbed-content-styles.scss';
import './tabbed-content';
